import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    maxWidth: 600,
    minWidth: 300,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  walletInfo: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    margin: '16px 0px'
  },
  walletInfoContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: theme.palette.grey[200],
    padding: 8
  },
  titleColor: {
    color: theme.palette.grey[500]
  },
  amountSection: {
    width: '100%',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '4fr 1fr',
    gap: 24
  },
  buttons: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 36
  },
  saveButton: {
    marginLeft: 12
  },
  bankOption: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    border: '1px solid transparent',
    backgroundColor: 'white',
    flex: 1,
    transition: 'all 0.2s ease'
  },
  selectedBank: {
    border: `1px solid ${theme.palette.grey[800]}`
  },
  disabledBank: {
    opacity: 0.5,
    pointerEvents: 'none'
  },

  termsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  banksContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  radioRoot: {
    '& svg': { fontSize: '14px' }
  },
  bank: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    },
    marginBottom: 8
  },
  bankSelected: {
    border: `1px solid ${theme.palette.text.primary}`,
    backgroundColor: theme.palette.grey[100]
  },
  bankIcon: {
    width: 48,
    height: 48
    // marginRight: theme.spacing(1)
  },
  bankLabel: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    fontSize: 12
  },
  gatewayContainer: {
    marginTop: 8,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  },
  skeletonBank: {
    width: 70,
    height: 70,
    borderRadius: 6,
    marginBottom: 8,
    background: theme.palette.grey[300],
    animation: `$pulse 1.5s ease-in-out infinite`
  },

  '@keyframes pulse': {
    '0%': { opacity: 0.6 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0.6 }
  }
}))

export default useStyles
